import { Box, Divider, FormControl, Grid, IconButton, InputBase, MenuItem, Select, Typography, makeStyles } from '@material-ui/core'
import SearchBarWithFilters from 'components/search_with_filters'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import useDebounce from 'lib/utils/debounce'
import MROButton from 'components/buttons'
import tableIcons, { options } from 'components/universal/table_attributes'
import MaterialTable from 'material-table'
import Warning from "assets/warning";
import CommercialIcon from 'assets/Commercial/Sales'
import TickIcon from 'assets/Commercial/Tick'
import { format24HrDateOnly, getColors, getOrganisationId } from 'lib/utils/common_utils'
import { Visibility } from '@material-ui/icons'
import Overview from 'views/Commercial/Parts/Sales/Overview'
import useGetFilterDetails from 'views/Commercial/Parts/FilterDetails'
import { DatePicker } from "antd";
import moment from 'moment';
import ManageSales from './ManageSales'
import RedCrossIcon from 'assets/Red remove icon.png'
import { ToastMessageContext } from 'lib/contexts/message_context'
import PartSalesServices from 'lib/services/api/commercial/parts'
import GetAppIcon from "@material-ui/icons/GetApp";
import { downloadFileFromUrl } from 'lib/utils/helperFunctions'
import Tablefilters from 'components/Tablefilters'
import DownloadCsv from 'components/DownloadCsv'
const { RangePicker } = DatePicker;




const useStyles = makeStyles((theme) => ({
    tableWrapper: {
        width: "95%",
        margin: "1% 3%",
    },



}))



function Sales(props) {
    const classes = useStyles();
    const { bases,
        accountStatus,
        sales,
        priority, customerDetails, accountInvoices } = useGetFilterDetails()
    const [searchText, setSearchText] = useState("");
    const debounceVal = useDebounce(searchText)
    const [filterData, setFilterData] = useState({ status: "Ready" });
    const [action, setAction] = useState(null)
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [totalCount, setTotalCount] = useState(10)
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [busy, setBusy] = useState(false)
    const message = useContext(ToastMessageContext)
    const [currentSelection, setCurrentSelection] = useState({})
    const [currency, setCurrency] = useState("")
    const [quoteData, setQuoteData] = useState([
        { id: "orders", name: "Orders", value: "0", color: "black", fontSize: "26px" },
        { id: "quote", name: "Quote", value: "0", color: "black", fontSize: "" },
        { id: "first_pending_order", name: "Pending", value: "0", color: "amber", fontSize: "" },
        { id: "first_ready", name: "Ready", value: "0", color: "green", fontSize: "" },
        { id: "first_invoiced", name: "Invoiced", value: "0", color: "red", fontSize: "" }])
    const [salesData, setSalesItem] = useState([
        { id: "second_quote", name: "Quote", value: "0", color: "black", fontSize: "" },
        { id: "pending_value", name: "Pending", value: "0", color: "amber", fontSize: "" },
        { id: "second_ready", name: "Ready", value: "0", color: "green", fontSize: "" },
        { id: "invoiced", name: "Unpaid", value: "0", color: "red", fontSize: "" }])


    // filters
    const handleFilterChange = (keyItem, value) => {

        setFilterData((prevState) => ({ ...prevState, [keyItem]: value }));
    };



    const tableOptions = {
        ...options,
        page: page,
        total: totalCount,
        pageSize: pageSize,
        toolbar: false,

    };
    const renderStateIcon = (rowData) => {

        const Icon = {
            0: <CommercialIcon fill={getColors("amber")} />,
            1: <CommercialIcon fill={getColors("green")} />,
            2: <TickIcon fill={getColors("green")} />,
            3: <TickIcon fill={getColors("green")} />


        }

        return rowData?.number_status > 3 ? <img src={RedCrossIcon} height={'20px'} /> : Icon[rowData?.number_status]

    }
    const handleDateChange = (value) => {
        if (value) {
            const fData = { ...filterData };
            fData["start_date"] = moment(value[0]).format("DD/MM/YYYY");
            fData["end_date"] = moment(value[1]).format("DD/MM/YYYY");
            setFilterData({ ...fData });
        } else {
            const fData = { ...filterData };
            filterData?.start_date && delete fData.start_date;
            filterData?.end_date && delete fData.end_date;
            setFilterData({ ...fData });
        }
    };





    // get details for overviewsection and table

    const params = useMemo(() => {
        return {
            organisation_id: getOrganisationId(),
            search_keyword: debounceVal,
            ...filterData,
        };
    }, [filterData, debounceVal]);

    const getListingDetails = async () => {
        const newParams = {
            ...params,
            page: page + 1,
            count_per_page: pageSize,
        };
        try {
            setLoading(true)
            const response = await PartSalesServices.getSalesMainlisting(newParams)
            if (response?.data) {
                setData(response.data)
                setTotalCount(response.total_count)
            }
            setLoading(false)
        }
        catch (error) {
            message.showToastMessage({ message: "Something went wrong. Try Again", variant: "error" });
            setLoading(false)
        }

    }


    useEffect(() => {
        getListingDetails();
    }, [params, page, pageSize]);

    const getOverViewDetails = async () => {
        try {

            const response = await PartSalesServices.getAccountsHeader(params)

            let q_value = quoteData.map((item) => {
                if (response.in_process.hasOwnProperty(item.id)) {
                    return {
                        ...item,
                        value: response.in_process[item.id].toString() // Convert value to string (optional)
                    };
                }
                return item;
            })

            setQuoteData(q_value)
            let s_value = salesData.map((item) => {
                if (response.sales_items.hasOwnProperty(item.id)) {
                    return {
                        ...item,
                        value: response.sales_items[item.id].toString() // Convert value to string (optional)
                    };
                }
                return item;
            })

            setSalesItem(s_value)
            setCurrency(response?.sales_items?.currency)
        }
        catch (error) {
            // message.showToastMessage({ message: "Something went wrong. Try Again", variant: "error" });
        }
    }

    useEffect(() => {
        getOverViewDetails()
    }, [params]);

    const downloadCsvHandler = async () => {
        setBusy("downloading");
        try {
            const newParams = {
                ...params,
                csv: true

            }

            const { file: fileUrl } = await PartSalesServices.getSalesMainlisting(newParams);


            // for downloading file automatically
            downloadFileFromUrl(fileUrl);
            message.showToastMessage({
                message: "File downloaded successfully",
                variant: "success",
            });
        } catch (error) {
            message.showToastMessage({
                message: "something went wrong!",
                variant: "error",
            });
        } finally {
            setBusy(null);
        }
    };


    const columns = [


        {
            title: "PS#",
            field: "order_number",
            headerStyle: {

                textAlign: "left",
                paddingLeft: "15px"
            },
            cellStyle: {

                textAlign: "left",
                paddingLeft: "15px"
            }
        },
        {
            title: "State",
            field: "status",
            render: (rowData) => renderStateIcon(rowData)

        },
        {
            title: "Priority",
            field: "priority",
            render: (rowData) => rowData?.priority === "high" ? <Warning fill={getColors("red")} /> : rowData?.priority === "medium" ? <Warning fill={getColors("amber")} /> : ""
        },
        {
            title: "Base",
            field: "base_station",


        },
        {
            title: "Date",
            field: "date",
            width: "10%",
            headerStyle: {
                width: "10%",
                textAlign: "left"
            },
            cellStyle: {
                width: "10%",
                textAlign: "left"
            },
            render: (rowData) => format24HrDateOnly(rowData?.date)
        },
        {
            title: "Customer",
            field: "customer",
            width: "15%",
            headerStyle: {
                width: "15%",
                textAlign: "left"
            },
            cellStyle: {
                width: "15%",
                textAlign: "left"
            }

        },
        {
            title: "Total",
            field: "total",
        },
        {
            title: "Currency",
            field: "currency",
        },
        {
            title: "Line Items",
            field: "line_item",
        },
        {
            title: "Total QTY",
            field: "total_qyt",
        }, {
            title: "Dispatch %",
            field: "dispatch",
        },
        {
            title: "Core Rtns",
            field: "core_return",
        }, {
            title: "Invoiced",
            field: "invoice",
            render: (rowData) => <span style={{ color: rowData?.account_invoice_color ? getColors(rowData?.account_invoice_color) : "", fontWeight: +rowData?.account_invoice === 0 ? "" : 600 }}>{rowData?.account_invoice || ""}</span>

        },

        {
            title: "Action",
            field: "action",
            render: (rowData) => <IconButton onClick={() => {
                setAction("view")
                setCurrentSelection(rowData)
            }}>
                <Visibility fontSize='small' />

            </IconButton>

        },

    ];

    const renderActionsPage = (value) => {
        const page = {
            "view": <ManageSales handleClose={() => {
                setAction(null)
                getListingDetails()
                getOverViewDetails()
            }} currentSelection={currentSelection} permission={props?.permission} />
        }
        return page[value]
    }

    const filterOptions = [

        { name: "base_station_id", options: bases || [], placeholder: "Base (All)", },
        { name: "line_customer_id", options: customerDetails || [], placeholder: "Customer (All)", },
        { name: "status", options: accountStatus || [], placeholder: "", },
        { name: "core_returns_tab", options: sales || [], placeholder: "" },
        { name: "priority", options: priority || [], placeholder: "", },
        { name: "invoiced", options: accountInvoices || [], placeholder: "" },




    ]




    return (
        <div className={classes.tableWrapper}>




            <SearchBarWithFilters handleSearch={setSearchText} searchText={searchText} padding={'4px 16px'} placeholder={'Search'}
            >



                {filterOptions && filterOptions.map(({ name, options, placeholder }) => (
                    <Tablefilters
                        key={name}
                        name={name}
                        options={options}
                        handleChange={handleFilterChange}
                        defaultValue={filterData[name]}
                        placeholder={placeholder}
                    />
                ))}



                <FormControl className="filter" >
                    <RangePicker
                        style={{ width: "291px" }}
                        format="DD/MM/YYYY"
                        // value={value}
                        onChange={handleDateChange}
                        allowClear={true}
                    />
                </FormControl>
                <Divider style={{ margin: "5px 0px 5px 0px" }} />
                <Typography color='primary' variant='subtitle2'>Overview</Typography>

                <Grid container spacing={2} style={{ padding: "15px 0px" }}>


                    <Overview title={"In Progress Invoicing"} data={quoteData} gridItem={3} />
                    <Overview title={`In Progress Value (${currency})`} data={salesData} gridItem={3} />
                    {/* <Overview title={"Core Returns Progress"} data={coreData} gridItem={2.4} /> */}

                </Grid>



            </SearchBarWithFilters>


            <br />
            <Box mt={"22px"}>
                <MaterialTable
                    style={{ boxShadow: "0px 1px 3px #00000033" }}
                    icons={tableIcons}
                    title={""}
                    columns={columns}
                    data={data || []}
                    isLoading={loading}
                    options={tableOptions}

                    onChangePage={(page) => {
                        setPage(page);
                    }}
                    onChangeRowsPerPage={(pageSize) => {
                        setPageSize(pageSize);
                    }}
                    totalCount={totalCount}
                    page={page}

                />
            </Box>
            <DownloadCsv
                startDate={filterData?.start_date}
                endDate={filterData?.end_date}
                isDateFilterPresent={true}
                onDownload={downloadCsvHandler}

            />

            {action && renderActionsPage(action)}
        </div>
    )
}

export default Sales